import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-内测资源申请表",
  "use": "icon-内测资源申请表-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-内测资源申请表\"><path fill=\"#333333\" d=\"M960 64H64C28.7 64 0 92.7 0 128v768c0 35.3 28.7 64 64 64h896c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64z m0 64v128H64V128h896z m0 768H64V320h896v576z\" /><path fill=\"#333333\" d=\"M864 576H736c-9.7 0-18.9 4.4-25 12l-99.2 124.1-168.4-280.6c-5.4-9-14.8-14.8-25.3-15.5-10.5-0.7-20.6 3.8-27.1 11.9L272.6 576H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c9.7 0 18.9-4.4 25-12l99.3-124.1 168.3 280.5c5.4 9 14.8 14.8 25.3 15.5 0.7 0 1.4 0.1 2.2 0.1 9.7 0 18.9-4.4 25-12l118.4-148H864c17.7 0 32-14.3 32-32s-14.3-32-32-32z\" /><path fill=\"#333333\" d=\"M160 192m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z\" /><path fill=\"#333333\" d=\"M288 192m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/内测资源申请表.svg
// module id = v0/e
// module chunks = 183